import { useState } from 'react';
import { CardContent, InputAdornment, IconButton, TextField } from '@mui/material';
 import ClearIcon from '@mui/icons-material/Clear';
 
 const Sideblock = ({title, list, openRes}) => {
  const [filter, setFilter] = useState('');

  if (!list) return null;
  return (
    <CardContent className="sidebar" sx={{paddingTop:0}}>
      <h3 style={{margin:'0.3em 0 0.1em 0'}}>{title}</h3>
{list.length > 0 &&       
      <TextField key={0} label={'Filter '+title} onChange={(e) => setFilter(e.target.value)} value={filter} fullWidth sx={{marginTop:0}}
        InputProps={{ endAdornment: <InputAdornment position="end"> <IconButton onClick={(e) => setFilter('')}> <ClearIcon /> </IconButton></InputAdornment> }} 
      /> 
}
{list.length <1 &&       
      <p style={{margin:'0.3em 0'}}>(No {title})</p>
}
  {list.map((s, k) => {
    if(filter==='' || (s.name+s.vorname).toLowerCase().includes(filter.toLowerCase())) {
      return <div key={k} className="sideblock-item" onClick={(e) => openRes(s.reservation_id)}>{s.res_nr} {s.vorname} {s.name} {s.bettlist}</div>
    }
    return null;
  })}
    </CardContent>
  )
};
export default Sideblock